import { z } from 'zod';
const paginationFields = {
  pageIndex: z.number().int().nonnegative().catch(0),
  pageSize: z.number().int().positive().max(2000).catch(100)
} as const;
const baseSearchFields = {
  operationPackageId: z.string().min(1),
  operationPackagePatternId: z.string().min(1)
} as const;

/** tag グループで確認画面を開く */
const tagGroupSearchSchema = z.object({
  ...baseSearchFields,
  tagId: z.string().min(1),
  ...paginationFields
});

/** anchorDate のみでグループ化された行の確認画面 */
const anchorDateGroupSearchSchema = z.object({
  ...baseSearchFields,
  anchorDate: z.string().min(1),
  ...paginationFields
});
export const SelfReportConfirmationSearchSchema = z.union([tagGroupSearchSchema, anchorDateGroupSearchSchema]);